import React, { useEffect, useState } from "react";
import { getFasce, setFasce } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Save, Sun, Sunrise, Sunset } from "lucide-react";
import { toast } from "sonner";

export default function FasceSettings() {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFasce().then((r) => setCfg(r.config)).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    try {
      await setFasce({
        mattina_presto_end_h: Number(cfg.mattina_presto_end_h),
        mattina_end_h: Number(cfg.mattina_end_h),
        pomeriggio_end_h: Number(cfg.pomeriggio_end_h),
      });
      toast.success("Fasce orarie aggiornate");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    }
  };

  if (loading || !cfg) return <div className="p-4 text-slate-500">Caricamento…</div>;

  return (
    <div className="space-y-4" data-testid="fasce-settings-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">Fasce orarie</h1>
        <p className="text-slate-500 text-sm mt-1">Confini delle fasce per il raggruppamento del giro</p>
      </div>

      <Card className="p-5 bg-white border border-slate-200 shadow-sm space-y-4">
        <Row
          icon={<Sunrise size={20} className="text-[#1B5E20]" />}
          title="Mattina presto"
          desc={`Tutti i produttori il cui orario inizia prima delle ${cfg.mattina_presto_end_h}:00`}
          value={cfg.mattina_presto_end_h}
          onChange={(v) => setCfg({ ...cfg, mattina_presto_end_h: v })}
          testid="mp-end-h"
        />
        <Row
          icon={<Sun size={20} className="text-[#0D9488]" />}
          title="Mattina"
          desc={`Tra ${cfg.mattina_presto_end_h}:00 e ${cfg.mattina_end_h}:00`}
          value={cfg.mattina_end_h}
          onChange={(v) => setCfg({ ...cfg, mattina_end_h: v })}
          testid="m-end-h"
        />
        <Row
          icon={<Sunset size={20} className="text-[#1565C0]" />}
          title="Pomeriggio"
          desc={`Tra ${cfg.mattina_end_h}:00 e ${cfg.pomeriggio_end_h}:00`}
          value={cfg.pomeriggio_end_h}
          onChange={(v) => setCfg({ ...cfg, pomeriggio_end_h: v })}
          testid="p-end-h"
        />
      </Card>

      <Card className="p-4 bg-[#F57C00]/10 border border-[#F57C00]/30">
        <div className="text-xs text-[#F57C00] font-semibold uppercase tracking-wider mb-1">Su appuntamento</div>
        <div className="text-sm text-slate-700">Sempre attivo per orari particolari (testo libero "su appuntamento" o non riconosciuto). Non configurabile.</div>
      </Card>

      <Button onClick={save} className="w-full h-12 bg-[#1B5E20] hover:bg-[#144818] text-white" data-testid="save-fasce-btn">
        <Save size={16} className="mr-2" /> Salva confini fasce
      </Button>
    </div>
  );
}

function Row({ icon, title, desc, value, onChange, testid }) {
  return (
    <div className="flex items-start gap-3">
      <div className="h-10 w-10 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">{icon}</div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>{title}</div>
        <div className="text-xs text-slate-500">{desc}</div>
      </div>
      <div className="w-20">
        <Label className="text-[10px]">Fine (h)</Label>
        <Input type="number" min={0} max={24} value={value} onChange={(e) => onChange(Number(e.target.value))} data-testid={testid} />
      </div>
    </div>
  );
}
